import type { Template } from "@/types";

export const PO_04_H1_V3: Template[] = [
    {
        id: "po-04-h1v3-01",
        name: "PO 01 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 44, y: 236, width: 218, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 269, y: 236, width: 490, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 766, y: 236, width: 219, height: 310, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 236, width: 218, height: 310, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-02",
        name: "PO 02 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "2", x: 103, y: 97, width: 420, height: 591, rotation: 0, imageRotation: 0 },
            { id: "1", x: 729, y: 97, width: 420, height: 296, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 399, width: 207, height: 287, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 399, width: 206, height: 287, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-03",
        name: "PO 03 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 36, y: 0, width: 555, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 697, y: 78, width: 474, height: 296, rotation: 0, imageRotation: 0 },
            { id: "3", x: 697, y: 380, width: 233, height: 324, rotation: 0, imageRotation: 0 },
            { id: "4", x: 938, y: 380, width: 233, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-04",
        name: "PO 04 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 42, y: 236, width: 492, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 541, y: 236, width: 219, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 236, width: 218, height: 310, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 236, width: 218, height: 310, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-05",
        name: "PO 05 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 98, y: 108, width: 210, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 316, y: 108, width: 210, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 98, y: 415, width: 428, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 708, y: 64, width: 461, height: 654, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-06",
        name: "PO 06 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 48, y: 267, width: 171, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 227, y: 267, width: 171, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 405, y: 267, width: 171, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 674, y: 226, width: 529, height: 331, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-07",
        name: "PO 07 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 40, y: 236, width: 216, height: 304, rotation: 0, imageRotation: 0 },
            { id: "2", x: 263, y: 134, width: 324, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 263, y: 344, width: 216, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 693, y: 0, width: 558, height: 783, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-08",
        name: "PO 08 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 88, y: 177, width: 156, height: 210, rotation: 0, imageRotation: 0 },
            { id: "2", x: 88, y: 394, width: 156, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 251, y: 177, width: 315, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 574, y: 177, width: 590, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-09",
        name: "PO 09 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 44, y: 236, width: 218, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 269, y: 236, width: 218, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 494, y: 236, width: 218, height: 310, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 236, width: 491, height: 310, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-10",
        name: "PO 10 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 62, y: 59, width: 966, height: 665, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1035, y: 59, width: 156, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1035, y: 283, width: 156, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1035, y: 507, width: 156, height: 217, rotation: 0, imageRotation: 0 }
        ],
    }
];